module.exports = "<button class=\"button\" [ngStyle]=\"customStyles\" [ngClass]=\"colorscheme +' '+ customClass\" [disabled]=\"disabled\" [type]=\"type\">\n  <i class=\"fa {{ icon }}\"></i>\n  {{ text | translate }}\n</button>\n"


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/button/button.component.html
// module id = ../../../../../src/app/components/button/button.component.html
// module chunks = main